import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import UklidKancelariBrno from "@/pages/UklidKancelariBrno";
import UklidBytovychDomuBrno from "@/pages/UklidBytovychDomuBrno";
import UklidProvozovenBrno from "@/pages/UklidProvozovenBrno";
import Rady from "@/pages/Rady";
import KolikStojiUklidKancelareBrno from "@/pages/articles/KolikStojiUklidKancelareBrno";
import JakCastoUklizetKancelare from "@/pages/articles/JakCastoUklizetKancelare";
import JakVybratUklidovouFirmu from "@/pages/articles/JakVybratUklidovouFirmu";
import UklidAdministrativnichBudov from "@/pages/articles/UklidAdministrativnichBudov";
import CoZahrnujePravidelnyUklid from "@/pages/articles/CoZahrnujePravidelnyUklid";
import OutsourcingUkliduVsVlastniZamestnanec from "@/pages/articles/OutsourcingUkliduVsVlastniZamestnanec";
import KolikStojiUklidAdministrativniBudovy from "@/pages/articles/KolikStojiUklidAdministrativniBudovy";
import JakPrevzitUklidOdJineFirmy from "@/pages/articles/JakPrevzitUklidOdJineFirmy";
import NejcastejsiChybySpravcuBudov from "@/pages/articles/NejcastejsiChybySpravcuBudov";
import VyberoveRizeniNaUklidKancelari from "@/pages/articles/VyberoveRizeniNaUklidKancelari";
import UklidKancelariPoRekonstrukci from "@/pages/articles/UklidKancelariPoRekonstrukci";
import JakPoznatKvalitniUklidovouFirmuBrno from "@/pages/articles/JakPoznatKvalitniUklidovouFirmuBrno";
import KontrolaKvalityUkliduKancelari from "@/pages/articles/KontrolaKvalityUkliduKancelari";
import KolikStojiUklidBytovehoDomuBrno from "@/pages/articles/KolikStojiUklidBytovehoDomuBrno";
import CoZahrnujeUklidSpolecnychProstorBytovehoDomu from "@/pages/articles/CoZahrnujeUklidSpolecnychProstorBytovehoDomu";
import JakVybratUklidovouFirmuProBytovyDum from "@/pages/articles/JakVybratUklidovouFirmuProBytovyDum";
import JakCastoUklidetSpolecneProstoryBytovehoDomu from "@/pages/articles/JakCastoUklidetSpolecneProstoryBytovehoDomu";
import { trackEvent } from "@/lib/analytics";
import "@/App.css";

// Restores scroll + honors hash anchors when navigating between routes.
// Also fires a Plausible SPA pageview on every path change (including
// the initial render — Plausible script is loaded in `manual` mode, so
// we own all pageview firings from the SPA layer).
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    trackEvent("pageview");
    if (hash) {
      const id = hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/uklid-kancelari-brno" element={<UklidKancelariBrno />} />
        <Route path="/uklid-bytovych-domu-brno" element={<UklidBytovychDomuBrno />} />
        <Route path="/uklid-provozoven-brno" element={<UklidProvozovenBrno />} />
        <Route path="/rady-pro-spravu-uklidu" element={<Rady />} />
        <Route
          path="/kolik-stoji-uklid-kancelari-brno"
          element={<KolikStojiUklidKancelareBrno />}
        />
        <Route
          path="/jak-casto-uklizet-kancelare"
          element={<JakCastoUklizetKancelare />}
        />
        <Route
          path="/jak-vybrat-uklidovou-firmu"
          element={<JakVybratUklidovouFirmu />}
        />
        <Route
          path="/uklid-administrativnich-budov"
          element={<UklidAdministrativnichBudov />}
        />
        <Route
          path="/co-zahrnuje-pravidelny-uklid-kancelari"
          element={<CoZahrnujePravidelnyUklid />}
        />
        <Route
          path="/outsourcing-uklidu-vs-vlastni-zamestnanec"
          element={<OutsourcingUkliduVsVlastniZamestnanec />}
        />
        <Route
          path="/kolik-stoji-uklid-administrativni-budovy-brno"
          element={<KolikStojiUklidAdministrativniBudovy />}
        />
        <Route
          path="/jak-prevzit-uklid-od-jine-uklidove-firmy"
          element={<JakPrevzitUklidOdJineFirmy />}
        />
        <Route
          path="/nejcastejsi-chyby-spravcu-budov-pri-zajisteni-uklidu"
          element={<NejcastejsiChybySpravcuBudov />}
        />
        <Route
          path="/vyberove-rizeni-na-uklid-kancelari"
          element={<VyberoveRizeniNaUklidKancelari />}
        />
        <Route
          path="/uklid-kancelari-po-rekonstrukci"
          element={<UklidKancelariPoRekonstrukci />}
        />
        <Route
          path="/jak-poznat-kvalitni-uklidovou-firmu-brno"
          element={<JakPoznatKvalitniUklidovouFirmuBrno />}
        />
        <Route
          path="/kontrola-kvality-uklidu-kancelari"
          element={<KontrolaKvalityUkliduKancelari />}
        />
        <Route
          path="/rady-pro-spravu-uklidu/kolik-stoji-uklid-bytoveho-domu-brno"
          element={<KolikStojiUklidBytovehoDomuBrno />}
        />
        <Route
          path="/rady-pro-spravu-uklidu/co-zahrnuje-uklid-spolecnych-prostor-bytoveho-domu"
          element={<CoZahrnujeUklidSpolecnychProstorBytovehoDomu />}
        />
        <Route
          path="/rady-pro-spravu-uklidu/jak-vybrat-uklidovou-firmu-pro-bytovy-dum"
          element={<JakVybratUklidovouFirmuProBytovyDum />}
        />
        <Route
          path="/rady-pro-spravu-uklidu/jak-casto-uklidet-spolecne-prostory-bytoveho-domu"
          element={<JakCastoUklidetSpolecneProstoryBytovehoDomu />}
        />
        <Route path="/o-nas" element={<About />} />
        <Route path="/ochrana-osobnich-udaju" element={<Privacy />} />
        <Route path="/obchodni-podminky" element={<Terms />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
